let dropdownStylesAdded = false;
let activeDropdowns = new Map();

function initDropdownPositioning() {
    if (!dropdownStylesAdded) {
        const style = document.createElement('style');
        style.textContent = `
           .table .dropdown-menu.show {
              position: absolute !important;
              z-index: 1070 !important;
              transform: none !important;
              top: auto !important;
              left: auto !important;
              bottom: auto !important;
              right: auto !important;
              margin: 0 !important;
              inset: unset !important;
              max-height: 300px !important;
              overflow-y: auto !important;
              pointer-events: auto !important;
           }
           .table .dropdown.show {
              position: static !important;
           }
           .dropdown-portal {
              position: absolute !important;
              top: 0 !important;
              left: 0 !important;
              z-index: 1070 !important;
              pointer-events: none !important;
           }
           .dropdown-portal .dropdown-menu {
              pointer-events: auto !important;
           }
        `;
        document.head.appendChild(style);
        dropdownStylesAdded = true;
    }

    function findDropdownElements(target) {
        const dropdownContainer = target.closest('.dropdown') || target.parentElement;
        const button = target.matches('[data-bs-toggle="dropdown"]')
            ? target
            : dropdownContainer?.querySelector('[data-bs-toggle="dropdown"]');
        const menu = dropdownContainer?.querySelector('.dropdown-menu');
        return { button, menu };
    }

    function createPortalContainer() {
        let portal = document.getElementById('dropdown-portal');
        if (!portal) {
            portal = document.createElement('div');
            portal.id = 'dropdown-portal';
            portal.className = 'dropdown-portal';
            document.body.appendChild(portal);
        }
        return portal;
    }

    function repositionDropdown(menu, button, originalParent) {
        if (!menu || !button || !document.contains(button) || !menu.classList.contains('show')) {
            return;
        }

        const portal = createPortalContainer();

        // Pokud menu není v portálu, přesuň ho tam
        if (menu.parentElement !== portal) {
            portal.appendChild(menu);
        }

        const buttonRect = button.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const gap = 2;

        // Reset pozice
        menu.style.transform = 'none';
        menu.style.webkitTransform = 'none';

        const menuRect = menu.getBoundingClientRect();

        let top = buttonRect.bottom + gap;
        let left = buttonRect.left;

        // Kontrola pravého okraje
        if (left + menuRect.width > viewportWidth - 10) {
            left = Math.max(10, viewportWidth - menuRect.width - 10);
        }

        // Kontrola levého okraje
        if (left < 10) {
            left = 10;
        }

        // Kontrola dolního okraje
        if (top + menuRect.height > viewportHeight - 10) {
            const spaceAbove = buttonRect.top - gap;
            if (spaceAbove >= 100) {
                top = Math.max(10, buttonRect.top - menuRect.height - gap);
            } else {
                const availableHeight = viewportHeight - top - 20;
                if (availableHeight >= 50) {
                    menu.style.maxHeight = `${availableHeight}px`;
                } else {
                    top = 10;
                    menu.style.maxHeight = `${viewportHeight - 40}px`;
                }
            }
        }

        if (top < 10) {
            top = 10;
        }

        // Nastavení pozice
        menu.style.position = 'absolute';
        menu.style.top = `${top}px`;
        menu.style.left = `${left}px`;
        menu.style.right = 'auto';
        menu.style.bottom = 'auto';
        menu.style.visibility = 'visible';
        menu.style.pointerEvents = 'auto';
        menu.style.zIndex = '1070';
    }

    function setupDropdownHandlers(button, menu) {
        if (activeDropdowns.has(menu)) return;

        // Uložit původní rodiče
        const originalParent = menu.parentElement;

        // Popper.js stop
        if (button._popper) {
            button._popper.destroy();
            button._popper = null;
        }

        activeDropdowns.set(menu, {
            button,
            originalParent
        });

        // Základní pozice - okamžitě
        repositionDropdown(menu, button, originalParent);

        // Pouze resize zavře dropdown
        window.addEventListener('resize', { passive: true });

        // Observer pro Popper.js interferenci - zavření při změně
        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (mutation.type === 'attributes' &&
                    mutation.attributeName === 'style' &&
                    mutation.target === menu) {
                    const style = menu.getAttribute('style') || '';
                    if (style.includes('transform:') && !style.includes('transform: none')) {
                        return;
                    }
                }
            }
        });

        observer.observe(menu, {
            attributes: true,
            attributeFilter: ['style']
        });

        activeDropdowns.get(menu).observer = observer;
    }

    document.addEventListener('show.bs.offcanvas', function(e) {
        document.querySelectorAll('.dropdown-menu.show').forEach(menu => {
            menu.classList.remove('show');
            const button = menu.closest('.dropdown')?.querySelector('[data-bs-toggle="dropdown"]');
            if (button) {
                button.classList.remove('show');
                button.setAttribute('aria-expanded', 'false');
            }
        });
    });

    function cleanupDropdown(menu) {
        const handlers = activeDropdowns.get(menu);
        if (!handlers) return;

        const { closeDropdown, observer, originalParent } = handlers;

        // Vrátit menu do původního rodiče
        if (originalParent && originalParent.isConnected) {
            try {
                originalParent.appendChild(menu);
            } catch (e) {
                console.warn('Could not restore menu to original parent:', e);
            }
        }

        // Vyčištění event listenerů
        window.removeEventListener('resize', closeDropdown);

        if (observer) {
            observer.disconnect();
        }

        activeDropdowns.delete(menu);

        // Vyčištění portálu pokud je prázdný
        const portal = document.getElementById('dropdown-portal');
        if (portal && portal.children.length === 0) {
            portal.remove();
        }
    }

    document.addEventListener('show.bs.dropdown', function (e) {
        if (!e.target.closest('.table')) return;

        const { button } = findDropdownElements(e.target);
        if (button?._popper) {
            button._popper.destroy();
            button._popper = null;
        }
    });

    document.addEventListener('shown.bs.dropdown', function (e) {
        if (!e.target.closest('.table')) return;

        const { button, menu } = findDropdownElements(e.target);
        if (button && menu) {
            setupDropdownHandlers(button, menu);
        }
    });

    document.addEventListener('hidden.bs.dropdown', function (e) {
        const { menu } = findDropdownElements(e.target);
        if (menu) {
            cleanupDropdown(menu);
        }
    });

    // Zkontroluj existující dropdowny
    const initExisting = () => {
        const openDropdowns = document.querySelectorAll('.table .dropdown-menu.show');
        openDropdowns.forEach(menu => {
            const { button } = findDropdownElements(menu);
            if (button && !activeDropdowns.has(menu)) {
                setupDropdownHandlers(button, menu);
            }
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initExisting);
    } else {
        setTimeout(initExisting, 0);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDropdownPositioning);
} else {
    initDropdownPositioning();
}
